var faq_card = ( function( $ ) {

	var $cards;

	var _init = function() {
		$cards = $( '.faq-card' );

		$cards.find( '.heading a' ).on( 'click', function( e ) {
			e.preventDefault();
		} );

		$cards.find( '.heading' ).on( 'click', _toggle );
	};


	var _toggle = function() {
		var $target = $( this ).parent();

		if ( $target.hasClass( 'open' ) ) {
			_hide_content( $target.find( '.faq-body' ) );

		} else {
			_hide_content( $cards.find( '.faq-body' ) );

			_show_content( $( this ).next() );
		}
	};

	var _hide_content = function( $element ) {
		$element.slideUp();
		$element.parent().removeClass( 'open' );
	};

	var _show_content = function( $element ) {
		$element.slideDown();
		$element.parent().addClass( 'open' );
	};

	if ( $( '.faq-card' ).length > 0 ) {
		$( document ).ready( _init );
	}

	return {};

} )( jQuery );

module.exports = faq_card;